import React from "react";

/**
 * ContinuacaoJornada, retomada suave de leitura.
 *
 * DECISÃO ARQUITETURAL D6 (aprovada): integrar com MinhaJornada backend
 * (progresso server-side), não localStorage. Endpoint alvo:
 * `GET /api/plans/user/journey` (a criar). Enquanto o endpoint não existir,
 * este componente permanece em silêncio elegante (retorna null).
 *
 * Quando o backend estiver pronto:
 *  - consumir /api/plans/user/journey (autenticado)
 *  - se null (sem jornada ativa) → retornar null
 *  - se houver jornada ativa → renderizar card com dia atual, progresso,
 *    e CTA "Continuar leitura" → /planos/{slug}?dia={n}
 */
export default function ContinuacaoJornada() {
  // Silêncio elegante até a integração server-side ser implementada.
  return null;
}
